module.exports = __webpack_public_path__ + "static/media/1001240TL.d3f027a8.jpg";